<p-dialog id="loading" [showHeader]="false" [modal]="true" [visible]="visible" (onHide)="visible = false" maskStyleClass="vh-total">
  <div class="d-flex align-items-center">
    <div class="spinner-border spinner-grow-sm" role="status">
      <span class="visually-hidden">Loading...</span>
    </div>
    <span class="ps-2">Carregando...</span>
  </div>
</p-dialog>
